export type WordEntry = {
  id: string;
  lemma: string;
  pronunciation?: string;
  partOfSpeech?: string;
  definitions: string[];
  examples?: string[];
};

export const MOCK_DICTIONARY: WordEntry[] = [
  {
    id: 'shalom',
    lemma: 'shalom',
    pronunciation: 'sha-LOM',
    partOfSpeech: 'noun',
    definitions: ['peace; harmony', 'well-being; completeness'],
    examples: ['Peace to you.'],
  },
  {
    id: 'libro',
    lemma: 'libro',
    pronunciation: 'LEE-broh',
    partOfSpeech: 'noun',
    definitions: ['book'],
    examples: ['I read a book every week.'],
  },
  {
    id: 'vag',
    lemma: 'vag',
    partOfSpeech: 'noun',
    definitions: ['dictionary project placeholder entry'],
    examples: ['Vag is a demo word entry for the frontend.'],
  },
];

